import axios from "axios";

export async function getNavigation() {
    return await axios
        .get(`${process.env.REACT_APP_API_URL}getNavigation.php`)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            return [];
        });
}
